"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrefsFromPartial = exports.DEFAULT_PREFS = exports.SettablePrefs = exports.Prefs = exports.SettableChillerSetPointTemperature = exports.SettableChillerSetPointTemperatureBounds = exports.ChillerSetPointTemperature = exports.ChillerSetPointTemperatureBounds = exports.HotTankMinimumTemperature = exports.HotTankMinimumTemperatureBounds = exports.HotTankSetPointTemperature = exports.HotTankSetPointTemperatureBounds = exports.Language = void 0;
const effect_1 = require("effect");
const schema_1 = require("../../../../schema");
const Unit = __importStar(require("../../../../unit"));
const number_1 = require("../../../../utils/number");
const NAMESPACE = 'Culligan.Device.Class.Gbfc.Prefs';
exports.Language = effect_1.Schema.transformLiterals(['bg', 'Bulgarian'], ['cs', 'Czech'], ['da', 'Danish'], ['de', 'German'], ['en', 'English'], ['es', 'Spanish'], ['fi', 'Finnish'], ['fr', 'French'], ['hu', 'Hungarian'], ['it', 'Italian'], ['lv', 'Latvian'], ['nb', 'Norwegian'], ['nl', 'Dutch'], ['pl', 'Polish'], ['pt', 'Portuguese'], ['sv', 'Swedish']).annotations({
    identifier: `${NAMESPACE}.Language`,
});
exports.HotTankSetPointTemperatureBounds = { min: 45, max: 90 };
exports.HotTankSetPointTemperature = Unit.Temperature.Celsius.fields.amount
    .pipe(effect_1.Schema.int(), effect_1.Schema.between(exports.HotTankSetPointTemperatureBounds.min, exports.HotTankSetPointTemperatureBounds.max), Unit.Into(Unit.Temperature.Celsius))
    .annotations({
    identifier: `${NAMESPACE}.HotTankSetPointTemperature`,
});
exports.HotTankMinimumTemperatureBounds = { min: 0, max: 87 };
exports.HotTankMinimumTemperature = Unit.Temperature.Celsius.fields.amount
    .pipe(effect_1.Schema.int(), effect_1.Schema.between(exports.HotTankMinimumTemperatureBounds.min, exports.HotTankMinimumTemperatureBounds.max), Unit.Into(Unit.Temperature.Celsius))
    .annotations({
    identifier: `${NAMESPACE}.HotTankMinimumTemperature`,
});
// The firmware supports 1..16, but some units in the field still report 0, likely kept from an
// older firmware that allowed it. Reported values keep accepting it; values the cloud sends do not.
exports.ChillerSetPointTemperatureBounds = { min: 0, max: 16 };
exports.ChillerSetPointTemperature = Unit.Temperature.Celsius.fields.amount
    .pipe(effect_1.Schema.int(), effect_1.Schema.between(exports.ChillerSetPointTemperatureBounds.min, exports.ChillerSetPointTemperatureBounds.max), Unit.Into(Unit.Temperature.Celsius))
    .annotations({
    identifier: `${NAMESPACE}.ChillerSetPointTemperature`,
});
exports.SettableChillerSetPointTemperatureBounds = {
    min: 1,
    max: 16,
};
exports.SettableChillerSetPointTemperature = Unit.Temperature.Celsius.fields.amount
    .pipe(effect_1.Schema.int(), effect_1.Schema.between(exports.SettableChillerSetPointTemperatureBounds.min, exports.SettableChillerSetPointTemperatureBounds.max), Unit.Into(Unit.Temperature.Celsius))
    .annotations({
    identifier: `${NAMESPACE}.SettableChillerSetPointTemperature`,
});
exports.Prefs = effect_1.Schema.Struct({
    // Legacy key: `lang`
    language: effect_1.Schema.propertySignature(exports.Language).annotations({
        title: 'Language',
        description: 'The language of the UI',
    }),
    // Legacy key: `unit`
    systemOfMeasure: effect_1.Schema.propertySignature(Unit.System).annotations({
        title: 'System of measure',
        description: 'The system of measure that will be used when displaying volumes and temperatures',
    }),
    // Legacy key: `htemp`
    hotTemperature: effect_1.Schema.propertySignature(exports.HotTankSetPointTemperature).annotations({
        title: 'Hot tank set point temperature',
        description: 'The temperature set point for the hot tank',
    }),
    minimumHotTankTemperature: effect_1.Schema.propertySignature(exports.HotTankMinimumTemperature).annotations({
        title: 'Hot tank minimum temperature',
        description: 'The temperature at which the hot tank should start heating again',
    }),
    // Legacy key: `ctemp`
    chilledTemperature: effect_1.Schema.propertySignature(exports.ChillerSetPointTemperature).annotations({
        title: 'Chiller set point temperature',
        description: 'The temperature set point for the chiller',
    }),
    // Legacy key: `drip_alarm`
    dripTrayFullCritical: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        title: 'Drip tray full critical?',
        description: 'Whether a full drip tray should disable dispensing',
    }),
    // Legacy key: `filter_stat`
    showFilterStatus: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        title: 'Show filter status?',
        description: 'Whether the filter status should be displayed on the UI',
    }),
    // Legacy key: `enable_c`
    coldEnabled: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        title: 'Cold water enabled?',
        description: 'Whether dispensing cold water is enabled',
    }),
    // Legacy key: `enable_h`
    hotEnabled: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        title: 'Hot water enabled?',
        description: 'Whether dispensing hot water is enabled',
    }),
    // Legacy key: `enable_e`
    extraHotEnabled: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        title: 'Extra hot water enabled?',
        description: 'Whether dispensing extra hot water is enabled',
    }),
    // Legacy key: `enable_l`
    lightlySparklingEnabled: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        title: 'Lightly sparkling water enabled?',
        description: 'Whether dispensing lightly sparkling water is enabled',
    }),
    // Legacy key: `loyalty`
    loyaltyEnabled: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        title: 'Loyalty system enabled?',
        description: 'Whether the loyalty system is enabled',
    }),
    // Legacy key: `enable_beta`
    betaFirmwareEnabled: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        title: 'Beta firmware enabled?',
        description: 'Whether this device is opted into receiving beta firmware updates',
    }),
    // Legacy key: `telemetry_p`
    telemetryInterval: effect_1.Schema.propertySignature(number_1.PositiveInt.pipe(Unit.Into(Unit.Time.Minute))).annotations({
        title: 'Telemetry message interval',
        description: 'The interval between D2C telemetry messages in minutes',
    }),
    // Legacy key: `state_p`
    stateInterval: effect_1.Schema.propertySignature(number_1.PositiveInt.pipe(Unit.Into(Unit.Time.Minute))).annotations({
        title: 'State message interval',
        description: 'The interval between D2C state messages in minutes',
    }),
    // Legacy key: `keepalive_p`
    keepaliveInterval: effect_1.Schema.propertySignature(number_1.PositiveInt.pipe(Unit.Into(Unit.Time.Second))).annotations({
        title: 'Keepalive message interval',
        description: 'The interval between D2C keepalive messages in seconds',
    }),
    // Legacy key: `heartbeat_p`
    heartbeatInterval: effect_1.Schema.propertySignature(number_1.PositiveInt.pipe(Unit.Into(Unit.Time.Minute))).annotations({
        title: 'Heartbeat message interval',
        description: 'The interval between D2C heartbeat messages in minutes',
    }),
    // Legacy key: `t_free`
    touchFreeEnabled: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        title: 'Touch-free dispense enabled?',
        description: 'Whether touch-free dispensing is enabled',
    }),
}).annotations({ identifier: `${NAMESPACE}.Prefs` });
exports.SettablePrefs = effect_1.Schema.Struct({
    ...exports.Prefs.fields,
    chilledTemperature: effect_1.Schema.propertySignature(exports.SettableChillerSetPointTemperature).annotations({
        title: 'Chiller set point temperature',
        description: 'The temperature set point for the chiller',
    }),
}).annotations({ identifier: `${NAMESPACE}.SettablePrefs` });
exports.DEFAULT_PREFS = {
    language: 'English',
    systemOfMeasure: 'SI',
    hotTemperature: Unit.Temperature.Celsius.make({ amount: 87 }),
    minimumHotTankTemperature: Unit.Temperature.Celsius.make({ amount: 0 }),
    chilledTemperature: Unit.Temperature.Celsius.make({ amount: 5 }),
    dripTrayFullCritical: true,
    showFilterStatus: false,
    coldEnabled: true,
    hotEnabled: true,
    extraHotEnabled: true,
    lightlySparklingEnabled: true,
    loyaltyEnabled: false,
    betaFirmwareEnabled: false,
    telemetryInterval: Unit.Time.Minute.make({ amount: 60 }),
    stateInterval: Unit.Time.Minute.make({ amount: 240 }),
    keepaliveInterval: Unit.Time.Second.make({ amount: 90 }),
    heartbeatInterval: Unit.Time.Minute.make({ amount: 15 }),
    touchFreeEnabled: true,
};
exports.PrefsFromPartial = (0, schema_1.StructFromPartial)(exports.DEFAULT_PREFS)(exports.Prefs).annotations({
    identifier: `${NAMESPACE}.PrefsFromPartial`,
});
//# sourceMappingURL=prefs.js.map